<rg-gauge-chart
        [canvasWidth]="chartWidth"
        [needleValue]="needleValue"
        [centralLabel]="centralLabel"
        [options]="options">
</rg-gauge-chart>